import styled from "styled-components";
import { COLORS } from "../../../../../styles/constants.style";

export const ParticipantsSearchResultWrapper = styled.div`
  margin: 19px 0px 39px;

  .form-header {
    display: flex;
    align-items: center;
    background-color: ${COLORS.primary_light_blue2};
    padding: 10px 16px;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }

  .selected-count {
    color: ${COLORS.cirrus_white};
    background-color: ${COLORS.cirrus_black7};
    padding: 2px 9px 4px 9px;
    border-radius: 8px;
    margin-left: 8px;
    height: 28px;
  }

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }

  .participant-name-link {
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .cell-assigned-coaches {
    display: flex;
    justify-content: center;
  }

  .MuiChip-label {
    align-items: center;
  }
`;
